import { DataBean } from "../DataBean";

export class AccountantIDForPayeable extends DataBean {


    public async getAccountantIDForPayeable(jsonCode:any,idPaymentFile:any,processType:any): Promise<any> {
        return this.getCustomService("QuickDataERPCore", "java.util.List_getAccountantIDForPayeable_String_Number_Number", [jsonCode,idPaymentFile,processType]);
    }

    

 
}